module.exports = __webpack_public_path__ + "img/laine-sinine.6bd0f4e2.svg";